// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zjsrc","footer":"styles_footer__2cdpT","passCodeTooltip":"styles_passCodeTooltip__GTqPr"};